export default __webpack_public_path__ + "static/media/banner1.3984978d.jpg";